import styled from 'styled-components';

export const ActiveStudentWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 300px;
`;
